import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigateService } from 'src/app/services/navigate/navigate.service';
import { ApiService } from 'src/app/services/api/api.service';
import { EventsService } from 'src/app/services/events.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ModalService } from '../modal/modal.service';
import { DataService } from 'src/app/services/data/data.service';
import { ServiceLogsService } from 'src/app/services/service-logs/service-logs.service';
import { CoreTranslateService, UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { config } from 'src/app/app.config';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit {
  @ViewChild('indicator', { static: false }) indicatorRef!: ElementRef;

  myProfile: any = {};
  themePrimaryColor ="#FFFFFF";
  themeSecondaryColor= "#FFFFFF";
  menuActive = '';
  mkpSystemCatagory: any = [];
  mkpCatagory: any = [];
  mkpCatagoryId = -2;
  mkpMyStore: any = {};
  isCanRegister: any = {};
  menuExplore = '';
  exploreStack: any = [];
  mkpFilterStr = '';
  activeIndex = -1;
  isIndicatorReady = false ;
  isFirstRenderDone = false;
  serviceCode = '';

  mainMenu = [
    {
      "ServiceID": 0,
      "ServiceCode": "home",
      "ServiceName": "Tab Home",
      "ServiceType": "TabContent",
      "TabDisplayOrder": 0,
      "TabIconImageUrl": '',
      "IsActive": true,
      "Url": null,
      "WebUrl": null,
      "IsDefault": false,
      "TabIconImageUrlActive": '',
      "ContentTypeName": "home",
      "ContentType": 0,
      "TabContentTypeName": "Home"
    },
  ]
  menuName = [
    {
      name: this.coreTranslate.getWord('TABS.HOME_PAGE'),
      link: "home"
    },
    {
      name: this.coreTranslate.getWord('TABS.BUY_SELL'),
      link: "marketplace"
    },
    {
      name: this.coreTranslate.getWord('TABS.SURVEY'),
      link: "survey"
    },
    {
      name: this.coreTranslate.getWord('TABS.REWARD'),
      link: "reward"
    },
    {
      name: this.coreTranslate.getWord('TABS.MY_LIST'),
      link: "myList"
    }
  ]
  menuNameMobile = [
    {
      name: this.coreTranslate.getWord('TABS.BUY_SELL'),
      link: "marketplace"
    },
    {
      name: this.coreTranslate.getWord('TABS.SURVEY'),
      link: "survey"
    },
    {
      name: this.coreTranslate.getWord('TABS.HOME_PAGE'),
      link: "home"
    },
    {
      name: this.coreTranslate.getWord('TABS.REWARD'),
      link: "reward"
    },
    {
      name: this.coreTranslate.getWord('TABS.MY_LIST'),
      link: "myList"
    }
  ]
  serviceTabList = [] ;
  serviceTabListDesktop = [] ;
  serviceTabListMobile = [] ;

  constructor(
    private router: Router,
    private location: Location,
    private navigate: NavigateService,
    private api: ApiService,
    private ev: EventsService,
    private ngxLoading: NgxUiLoaderService,
    private modalServe: ModalService,
    public dataService: DataService,
    private servLog: ServiceLogsService,
    private utility: UtilitysService,
    private renderer: Renderer2,
    private coreTranslate: CoreTranslateService,
    private activatedRoute: ActivatedRoute,
  ) { 
    this.dataService.load().then(res => {}, () => {});
    this.location.onUrlChange(url => this.setCurrentMenu(url));
  }

  ngOnInit() {
    this.getServicetab();
    this.ev.onReloadMyProfile.subscribe(res => {
      this.getMyProfile(true);
    });

    this.ev.onServiceClick.subscribe(res => {
      this.onServiceClick(res.item, res.isCheckEnable);
    });

    this.ev.onSwichPage.subscribe(res => {
      this.swichPage(res.route);
    });

    this.ev.onMenuClick.subscribe(res => {
      this.onMenuClick(res.page);
      this.setCurrentMenu(res.page);
    });

    this.ev.onGotoMyStore.subscribe(res => {
      this.gotoStore();
    });

    this.ev.onMarketHomeFilter.subscribe(res => {
      this.mkpFilterStr = res.str;
      this.getMarketPlaceList(this.mkpFilterStr, true);
    });

    this.ev.onMkpCatagoryReloadByPaging.subscribe(res => {
      this.getMarketPlaceList(this.mkpFilterStr, false, res.p);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setCurrentMenu(event.urlAfterRedirects);
      }
    });

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.serviceCode = params.get('code') || '';
    });
    
  }
  async getMyProfile(forceRefresh = false) {
     this.myProfile = await this.utility.getMyProfile(true, true, false, forceRefresh);
     this.themePrimaryColor = this.myProfile.Template.PrimaryColor;
     this.themeSecondaryColor = this.myProfile.Template.SecondaryColor;
   
     var primaryColorRGB = this.convertToRGB(this.myProfile.Template.PrimaryColor.slice(1) );
     var primaryColorLight = ["rgba(",primaryColorRGB[0] - 40,",",primaryColorRGB[1]- 40,",",primaryColorRGB[2]- 10,",0.1",")"].join("");
    //  console.log(primaryColorLight);
    //  var test = this.convertToRGB("1E22AA");
    //  console.log(test);
     this.changeColor(this.themePrimaryColor,this.themeSecondaryColor,primaryColorLight);
  }
  changeColor(primaryColor:string,secondaryColor:string,primaryColorLight:string){
    document.documentElement.style.setProperty('--app-primary', primaryColor);
    document.documentElement.style.setProperty('--app-secondary', secondaryColor);
    document.documentElement.style.setProperty('--app-primary_light', primaryColorLight);
  }
  setCurrentMenu(url: any, animate: boolean = true) {
    this.utility.getMyProfile();
    // this.menuActive = 'home';
    if(url.includes('home')  || url.includes('content')){
      this.menuActive = 'home';
    } else if(url.includes('explore')){
      this.menuActive = 'explore';
    } else if(url.includes('profile')){
      this.menuActive = '';
    } else if(url.includes('servey')){
      this.menuActive = 'servey';
    } else if(url.includes('reward')){
      this.menuActive = 'reward';
    } else if(url.includes('survey')){
      this.menuActive = 'survey';
    }  else if(url.includes('marketplace')){
      this.menuActive = 'marketplace';
      this.getMarketPlaceList();
    } else if (url.includes('news')) {
      this.menuActive = 'news';
    } else if (url.includes('activity')) {
      this.menuActive = 'activity';
    } else if (url.includes('points-leaderboard')) {
      this.menuActive = 'leaderboard';
    } else if (url.includes('course-history')) {
      this.menuActive = 'coursehistory';
    } else if (url.includes('mypoints') || url.includes('my-points')) {
      this.menuActive = 'mypoints';
    } else if (url.includes('point-transfer')) {
      this.menuActive = 'pointtransfer';
    } else {
      this.menuActive = ''; 
    }

    // console.log('menu',this.menuActive);
    // console.log('serviceCode', this.serviceCode)

    this.setActiveIndexByMenu(animate);
  }

  onMenuClick(p: string) {
    if(p.includes('explore')) {
      this.menuExplore = 'explore';
    } else if(p.includes('activity')) {
      this.navigate.navigateMenu('activity?tab=last&page=1');
    } else if(p.includes('myList') || p === 'MyShelf') {
      this.navigate.navigateToUrlAndCheckToken(config.myList);
    } else if(p.toString().toLowerCase().includes('survey')) {
      this.navigate.navigateMenu('survey');
    }  
    else {
      this.navigate.navigateMenu(p.toString().toLowerCase());
    }
  }

  getMarketCatagory(cat: any){
    this.mkpSystemCatagory = [];
    this.mkpCatagory = [];

    if(cat){
      cat.forEach(e => {
        if(e.Id == -1 || e.Id == -2) {
          this.mkpSystemCatagory.push(e);
        } else {
          this.mkpCatagory.push(e);
        }
      });
    }
  }

  getMarketPlaceList(search = '', isSpriner = true, p = 1) {
    if(isSpriner) this.ngxLoading.start();

    return new Promise((resolve) => {
      this.api.getMarketPlaceList(1, this.mkpCatagoryId, p, search).subscribe((res: any) => {
        this.mkpMyStore = res.Results;
        this.getMarketCatagory(res.Results.Category);
        let cat = res.Results.Category.filter(w => w.Id  == this.mkpCatagoryId);
        this.ev.onMkpCatagory.emit({item: cat ? cat[0] : cat, p, banners: res.Results.BannerUrl});
        this.ngxLoading.stopAll();
        resolve(res);
      }, err => {
        this.ngxLoading.stopAll();
        resolve(null);
        console.error(err);
      });
    });
  }

  async onMkpMenuClick(item: any){
    this.mkpCatagoryId = item.Id;
    this.navigate.navigateMenu('marketplace');
    this.getMarketPlaceList();
  }

  async gotoStore() {
    if(!this.mkpMyStore.MerchantId && this.mkpMyStore.IsAllowRegister){
      this.isCanRegister = (await this.canRegister());
      if(!this.isCanRegister.canRegister) {
        this.modalServe.onInfo.emit({title: 'การลงทะเบียนร้านค้า', content: this.isCanRegister.msg, callback: res=> {}});
        return;
      }

      this.modalServe.onMarketStoreCreate.emit({callback: res => {
        if(res.status == 'success') {
          this.getMarketPlaceList();
          this.modalServe.onMarketCreateStoreSuccess.emit({callback: ()=>{}});
        }
      }});
    } else if(!this.mkpMyStore.MerchantId && !this.mkpMyStore.IsAllowRegister) {
        this.isCanRegister = (await this.canRegister());
        if(!this.isCanRegister.canRegister) {
          this.modalServe.onConfirm.emit({title: 'การลงทะเบียนร้านค้า', content: this.isCanRegister.msg, callback: res=> {}});
          return;
        }
    } else {
      this.navigate.navigateMenu('marketplace-my-store');
    }
  }

  gotoInterestedHistory() {
    this.navigate.navigateMenu('marketplace-my-product-interested');
  }

  canRegister(): Promise<any> {
    return new Promise((resolve: any) => {
      this.api.getMarketPlaceCanRegister().subscribe(res => {
        if (res.Code == 200) {
          resolve({canRegister: true, msg: ''});
        } else {
          resolve({canRegister: false, msg: res.Message});
        }
      }, err => {
        console.error(err);
        resolve({canRegister: false});
      });
    });
  }

  onServiceClick(item: any, isCheckEnable = true) {
    if(item && isCheckEnable ? (('IsEnable' in item) ? item.IsEnable : true) : true){
      this.saveServiceLogs(item);
      
      let route: any = this.navigate.navigateTo(item);
      // console.log(route);
   
      this.swichPage(route);
    }
  }

  swichPage(route: any) {
    // this.menuActive = 'home';
    console.log('route',route);
    switch(route.type){
      case 'marketplace':
        this.navigate.navigateMenu('marketplace');
        break;
      case 'reward':
        this.navigate.navigateMenu('reward' + (route.id ? '?id=' + route.id : ''));
        break;
      case 'service':
        this.menuActive = 'explore';
        this.menuExplore = 'explore';
        this.getSubService(route.serviceCode);
        return;
      case 'news':
        this.navigate.navigateMenu('news?code='+route.serviceCode+'&page=1');
        break;
      case 'news-detail':
        this.navigate.navigateMenu('news-detail?id='+route.id);
        break;
      case 'content':
        this.navigate.navigateMenu('content?code='+route.serviceCode+'&page=1');
        break;
      case 'content-detail':
        this.navigate.navigateMenu('content-detail?id='+route.id);
        break;
      case 'activity':
        this.navigate.navigateMenu('activity?code='+route.serviceCode+'&page=1&tab=last');
        break;
      case 'activity-detail':
        this.navigate.navigateMenu('activity-detail?id='+route.id);
        break;
      case 'notification-view':
        this.menuActive = 'notification-view';
        this.navigate.navigateMenu('notification-view?id='+route.id+'&type='+route.isToday);
        break;  
      case 'marketplace-my-product-detail':
        this.navigate.navigateMenu('marketplace-my-product-detail?product='+route.id);
        break;  
      case 'marketplace-interested-info':
        this.navigate.navigateMenu('marketplace-interested-info?product='+route.id);
        break;
      case 'survey':
        this.navigate.navigateMenu('survey' + (route.id ? '?id=' + route.id : ''));
        break;  
      case 'survey-topic':
        this.navigate.navigateMenu('survey-topic?id='+route.id);
        break;
      case 'survey-question':
        this.navigate.navigateMenu('survey-question?id='+route.id);
        break;
      case 'reel':
        this.navigate.navigateMenu('video');
        break;
      case 'leaderboard':
        this.navigate.navigateMenu('points-leaderboard');
        break;
      case 'course-history':
        this.navigate.navigateMenu('course-history');
        break;
      case 'mypoints':
        this.navigate.navigateMenu('mypoints');
        break;
      case 'point-transfer':
        this.navigate.navigateMenu('point-transfer');
        break;
      default:
        break;
    }
    if (route.type !== 'service') {
      this.menuExplore = '';
      this.exploreStack = [];
    }
    this.setCurrentMenu(this.router.url, false);
  }

  getSubService(serviceCode: any) {
    this.ngxLoading.start();
    this.api.getServiceDetail(serviceCode).subscribe((res: any) => {
      if(res.Code === 200){
        this.exploreStack.push(res.Results);
      } else {
        console.error(res);
      }
      this.ngxLoading.stopAll();
    }, (err: any) => {
      console.error(err);
      this.ngxLoading.stopAll();
    });
  }

  popSubService(index: any) {
    this.exploreStack.splice(index, 1);
  }

  saveServiceLogs(service: any){
    this.servLog.modifyServiceLog(service);
  }
  convertToRGB(color : any){
    
    if(color.length != 6){
        throw "Only six-digit hex colors are allowed.";
    }

    var aRgbHex = color.match(/.{1,2}/g);
    var aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    return aRgb;
    //return ["rgb(",aRgb[0],",",aRgb[1],",",aRgb[2],")"].join("");
}

  getServicetab() {
    this.ngxLoading.start();
    this.api.getServiceTab().subscribe((res: any) => {
      if(res.Code === 200){
        this.serviceTabList = res.Results;

        this.serviceTabListDesktop = [
          this.mainMenu[0],
          ...this.serviceTabList
        ]

        this.serviceTabListMobile = res.Results;
        this.serviceTabListMobile.splice(2, 0, this.mainMenu[0]);

      } else {
        // console.error(res);
        this.serviceTabList = [];
        this.serviceTabListDesktop = [];
        this.serviceTabListMobile = [] ;
      }
      this.ngxLoading.stopAll();

      // setTimeout(() => {
      //   this.setCurrentMenu(this.router.url, false); 
      // }, 100); 
    }, (err: any) => {
      console.error(err);
      this.ngxLoading.stopAll();
    });
  }

  getDisplayNameMenu(tab: any): string {
    const index = tab;
    return this.menuName[index]["name"] ;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setCurrentMenu(this.router.url, false);
    }, 100);  // หน่วงเวลาเล็กน้อยเพื่อให้มั่นใจว่า DOM ถูกโหลดเสร็จแล้ว
  }

  setActiveIndexByMenu(animate: boolean = true): void {
    if (!this.menuActive || this.menuActive === '') return;

    if( this.activeIndex === -1) {
      const index = this.serviceTabListMobile.findIndex(item =>{
        const type = item.ContentTypeName;

        return ((item.ServiceType !== 'TabContent' && type &&
              ((type.toString().toLowerCase() === this.menuActive && this.serviceCode && this.serviceCode === item.ServiceCode) ||
              (type.toString().toLowerCase() === this.menuActive))) || 
              (item.ServiceType === 'TabContent' && 
              (item.TabContentTypeName.toString().toLowerCase() === this.menuActive) ||
              (item.TabContentTypeName === 'SurveyGroup' && this.menuActive === 'survey')
            ) 
          );
        // item.ContentTypeName && item.ContentTypeName.toString().toLowerCase() === this.menuActive && (this.serviceCode !== '' && this.serviceCode === item.ServiceCode)
      });

      if (index === -1) return;
    
      this.activeIndex = index;
    }

    // console.log('activeIndex', this.activeIndex);
  
    setTimeout(() => {
      this.isIndicatorReady = true;
      this.moveIndicator(this.activeIndex, false); // disable animation ครั้งแรก
      this.isFirstRenderDone = true;
    }, 0); // หน่วงให้น้อยที่สุดเพื่อรอ DOM
    
  }
  
  moveIndicator(index: number, animate: boolean = true) {
    if (!this.isIndicatorReady || index < 0 || !this.indicatorRef) return;
  
    const indicator = this.indicatorRef.nativeElement as HTMLElement;
    // console.log('indicator',indicator);
    const translateValue = `${index * 100}% 0`;
  
    this.renderer.setStyle(indicator, 'translate', translateValue);
    this.renderer.setStyle(indicator, 'transition', animate ? 'translate 0.3s ease' : 'none');
  }
  
}
